import { t } from "i18next";
import React from "react";

const CareerCard = (props) => {
  const { cTitle, cOpenings, cDetails, onClick } = props;
  return (
    <>
      <div className="col-md-6 col-lg-4 mb-4">
        <div className="company-info-wrapper">
          <div className="right-part">
            <div className="top-block">
              <div className="left-block">
                <div className="content-block">
                  <h5>{cTitle}</h5>
                </div>
              </div>
              <div className="right-block">
                <h4>
                  {t("openings")}<span>{cOpenings}</span>
                </h4>
              </div>
            </div>
            <p>{cDetails}</p>
            <div className="text-end">
              <a
                href="#"
                type="button"
                className="btn view-more"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                onClick={onClick}
              >
                {t("apply_for")} <i className="fa-solid fa-chevron-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerCard;
